/**
 * What a building is called right now, closed or not.
 *
 * PURE, AND OUT OF THE ENGINE ON PURPOSE. jsdom has no 2D context, so nothing
 * inside `onTextLayer` can be tested at all — the same constraint pathfind.js
 * and zoneShapes.js were split out under. The words are the part worth pinning;
 * the `fillText` around them is not.
 *
 * THE WORDS ARE SHORT BECAUSE THE CANVAS IS 320x180 and this is drawn at a 7px
 * glyph. "Closed for refurbishment until Tuesday" would be wider than the
 * building it is sitting on.
 */

/**
 * The reasons the server sends, as words.
 *
 * Keyed by the strings in `CLOSED_REASONS` — server/game/businessHours.js
 * decides which one applies, so the world and the admin badge cannot disagree
 * about whether somewhere is shut.
 *
 * THREE PHRASES RATHER THAN ONE, because they are not the same news. A shop
 * shut for the night will be open tomorrow; one shut down will not, and walking
 * back at nine to find out is a waste of a trip.
 */
export const CLOSED_WORDS = {
  hours: 'closed',
  temporary: 'closed for now',
  permanent: 'closed down',
  soon: 'coming soon',
};

/**
 * @param {{id: string, label: string}} zone
 * @param {{username: string}|null|undefined} owner
 * @param {string|null|undefined} reason one of CLOSED_REASONS, or nothing
 * @returns {string} empty when there is nothing worth drawing
 */
export function zoneLabelFor(zone, owner, reason) {
  // An owned building is worth naming even if the world author never gave it
  // one — "Jason's place" beats an unlabelled box.
  const base = owner?.username
    ? `${owner.username}'s ${zone.label || 'place'}`
    : zone.label;

  // Nothing to say. An unlabelled, unowned building stays anonymous whether it
  // is open or not — writing "(closed)" over a blank box names nothing.
  if (!base) return '';

  // An unrecognised reason falls through to the plain label rather than
  // rendering "undefined", which is what a mismatch between the mirrored
  // constants would otherwise look like on screen.
  const words = CLOSED_WORDS[reason];
  return words ? `${base} (${words})` : base;
}

export default zoneLabelFor;
